import Link from 'next/link'
import Select from 'react-select'
import { setLanguage } from '../../reducers/localization'
import { withI18next } from '../../lib/withI18next'
import { getS3PdfWithLocale } from '../../lib/helpers'

const LANGUAGES = [
  {
    value: 'en',
    label: <span className="ma-language-selector-item is-clearfix">
      <img src="/static/images/flags/flags-iso/flat/32/US.png" /><span>English</span>
    </span>
  },
  {
    value: 'fr',
    label: <span className="ma-language-selector-item is-clearfix">
      <img src="/static/images/flags/flags-iso/flat/32/FR.png" /><span>French</span>
    </span>
  }
]

const handleLanguageChange = lang => {
  setLanguage(lang.value)
}

const Footer = props => {
  const selectedLanguage = LANGUAGES.filter(lang => lang.value === props.currentLanguage)
  return (
    <footer className="footer">
      <div className="ma-footer">
        <Select
          className="ma-language-selector"
          instanceId="ma-language-selector"
          value={selectedLanguage}
          onChange={handleLanguageChange}
          options={LANGUAGES}
          />
        <ul className="ma-footer-menu m-b-sm is-clearfix">
          <li>
            <a
              href={getS3PdfWithLocale('MazdaServiceInfo_Site_Usage_Agreement', props.i18n.language)}
              target="_blank">
              {props.t('common:site-usage-agreement')}
            </a>
          </li>
          <li><Link href="/contact"><a>{props.t('common:contact-us')}</a></Link></li>
          <li>
            <a
              href={getS3PdfWithLocale('MazdaServiceInfo_Privacy', props.i18n.language)}
              target="_blank">
              {props.t('common:privacy')}
            </a>
          </li>
          <li>
            <a
              href={getS3PdfWithLocale('MazdaServiceInfo_FAQs', props.i18n.language)}
              target="_blank">
              {props.t('common:faq')}
            </a>
          </li>
        </ul>
        <p className="m-b-md">
          {props.t('footer_browser-support')} <a href="http://www.mazda.com/" target="_blank">www.mazda.com</a>
        </p>
        <p>{props.t('common:footer_privacy')}</p>
      </div>
    </footer>
  )
}

export default  withI18next(['common'])(Footer)



// WEBPACK FOOTER //
// ./components/Footer/index.js